import React from "react";
import { Box } from "@material-ui/core";
import NoteItem from "../NoteItem/NoteItem";

const NotesList = ({ notes }) => {
  return (
    <Box style={{ overflowY: "auto", flex: 1 }}>
      {notes.map((note) => (
        <NoteItem key={note.noteID} note={note} />
      ))}
    </Box>
  );
};

export default NotesList;
